import * as yup from 'yup';
import { getDateSchema } from '@/components/tripBookingPage/formItems/dateSelector/dateSelector';
import { getTripTypeSchema } from '@/components/tripBookingPage/formItems/tripType/tripTypeFormItem';
import { type BookingFormStepperPropsRaw, FormMode } from '@/components/tripBookingPage/tripBooking';
import type { FormItemConfigCallbackData } from '@/types';

export function getStepOneItems(): BookingFormStepperPropsRaw {
  return {
    title: (data: FormItemConfigCallbackData, options) => {
      const useShortTitle = data.formMode === FormMode.Modification || data.formMode === FormMode.Duplicate;

      return options.t(useShortTitle
        ? 'pages.tripBooking.forms.dated.stepTitles.stepOne.modification'
        : 'pages.tripBooking.forms.dated.stepTitles.stepOne.creation');
    },
    items: [
      {
        name: 'tripType',
        title: 'pages.tripBooking.forms.items.tripType.label',
      },
      {
        name: 'date',
        title: 'pages.tripBooking.forms.dated.serviceRequestDate.label',
      },
    ],
  };
}

export const stepOneFormSchema = yup.object({
  date: getDateSchema(),
  tripType: getTripTypeSchema(),
});

export type StepOneFormSchema = yup.InferType<typeof stepOneFormSchema>;
